import { ChangeDetectorRef, ElementRef, Injectable, QueryList } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { ChatStateService } from '../app-state-services/chat-main/chat-state.service';

@Injectable({
  providedIn: 'root'
})
export class TextToSpeechService {
  private synth = window.speechSynthesis;
  private voices: SpeechSynthesisVoice[] = [];
  private defaultVoiceName: string = 'Google US English';
  private currentUtterance: SpeechSynthesisUtterance | null = null;
  isSpeakingPausedInBetween: boolean = false; 
  intervalForStreamResponseSpeaking : any; 
  streamingResponseArray: string[] = []
  currentQnaId: any = ""
  currentUserQnaIndex : number = -1; 

  private isVirtualAgentSpeakingState = new BehaviorSubject<boolean>(false); 
  isVirtualAgentSpeaking$ = this.isVirtualAgentSpeakingState.asObservable(); 

  messageContainers!: QueryList<ElementRef>;

  constructor(
    private chatStateService: ChatStateService,
  ) {
    this.initialize();
  }

  initialize() {
    this.intervalForStreamResponseSpeaking = setInterval(() => {
      this.proceedStreaminResponse(); 
    }, 100);
  }

  private populateVoiceList() {
    this.voices = this.synth.getVoices();
  }

  public speak(text: string, qnaId: string, cdr: ChangeDetectorRef) {
    this.stop();
    this.isVirtualAgentSpeakingState.next(true); 

    this.currentUtterance = new SpeechSynthesisUtterance(text);
    this.currentUtterance.rate = 1; 

    this.currentUtterance.onerror = (event) => {
      console.error('Speech synthesis error:', event.error);
    };

    this.currentUtterance.onend = () => {
      this.chatStateService.updateVirtualAgentSpeaking(qnaId, false);
      this.isSpeakingPausedInBetween = false;
      this.isVirtualAgentSpeakingState.next(false); 
      cdr.detectChanges(); 
    };
    this.synth.speak(this.currentUtterance);
  }

  public speakStreamMessage(text: string) {
    if(this.isSpeakingPausedInBetween) {
      this.stop(); 
      this.isSpeakingPausedInBetween = false;  
    }

    this.streamingResponseArray.push(text); 
  }

  private proceedStreaminResponse() {
    const length = this.streamingResponseArray.length; 

    if(length > 0 && (this.streamingResponseArray[length-1].includes('.') || this.streamingResponseArray[length-1].includes(','))) {
      const currentMessage = this.formatMessage(this.streamingResponseArray.join('')); 
      this.streamingResponseArray = []; 
      this.currentUtterance = new SpeechSynthesisUtterance(currentMessage);
      this.currentUtterance.rate = 1; 

      this.currentUtterance.onerror = (event) => {
        console.error('Speech synthesis error:', event.error);
      };
      this.synth.speak(this.currentUtterance);
    }
  }

  public stop() {
    this.synth.cancel();
    this.currentUtterance = null;
  }

  public pause() {
    this.isSpeakingPausedInBetween = true; 
    this.isVirtualAgentSpeakingState.next(false); 
    this.synth.pause();
    
  }

  public resume() {
    this.isVirtualAgentSpeakingState.next(true);
    this.synth.resume();
  }

  public getVoices(): SpeechSynthesisVoice[] {
    return this.voices;
  }

  formatMessage(message: string): string {
    return this.chatStateService.formatResponseMessage(message);
  }
}